import { render, staticRenderFns } from "./ExtraWorkArchive.vue?vue&type=template&id=0c723597&scoped=true&"
import script from "./ExtraWorkArchive.vue?vue&type=script&lang=js&"
export * from "./ExtraWorkArchive.vue?vue&type=script&lang=js&"
import style0 from "./ExtraWorkArchive.vue?vue&type=style&index=0&id=0c723597&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c723597",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCardActions,VCol,VRow,VSelect,VSpacer})
